var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnagraficaBarche',{staticClass:"pa-5",staticStyle:{"border-radius":"0px"},attrs:{"flagEM":true},on:{"click_indietro":_vm.handleClickIndietro}})
}
var staticRenderFns = []

export { render, staticRenderFns }